const createReducer = (initialState, handlers) => (state = initialState, { type, payload }) =>
  handlers[type] ? handlers[type](state, payload) : state;

export default createReducer;
